import React, { useEffect, useRef } from 'react';
import './Resume.css';

const Resume = () => {
  const sectionRefs = {
    projects: useRef(null),
    experience: useRef(null),
    skills: useRef(null)
  };

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.15
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    Object.values(sectionRefs).forEach(ref => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      Object.values(sectionRefs).forEach(ref => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, []);

  return (
    <section className="resume" id="resume">
      <div className="container resume-container">
        <div 
          className="resume-section projects" 
          id="projects" 
          ref={sectionRefs.projects}
        >
          <h2 className="section-title">Projects</h2>
          
          <div className="projects-grid">
            <div className="project-card">
              <div className="project-header">
                <h3>Gachi Grills</h3>
                <span className="project-tag glow-pulse">D2C Brand</span>
              </div>
              <p className="project-description">
                Direct-to-consumer foldable KBBQ table brand with explosive social media growth
                and an engaged community of Korean BBQ Lovers.
              </p>
              <div className="project-metrics">
                <div className="metric">
                  <span className="metric-value">25K</span>
                  <span className="metric-label">Instagram Followers</span>
                </div>
                <div className="metric">
                  <span className="metric-value">$27K</span>
                  <span className="metric-label">Revenue in 3 Weeks</span>
                </div>
              </div>
            </div>

                <div className="project-card">
              <div className="project-header">
                <h3>AI Insurance Lead-Gen</h3>
                <span className="project-tag glow-pulse">B2B SaaS</span>
              </div>
              <p className="project-description">
                AI-powered qualification platform that transforms 15-minute calls into 60-second warm leads,
                with integrated lead scoring and workflow automation.
              </p>
              <div className="project-metrics">
                <div className="metric">
                  <span className="metric-value">60s</span>
                  <span className="metric-label">Warm Leads</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div 
          className="resume-section experience" 
          id="experience" 
          ref={sectionRefs.experience}
        >
          <h2 className="section-title">Professional Experience</h2>
          
          <div className="experience-item">
            <div className="experience-header">
              <h3>Contract Developer, AI Insurance Lead-Gen</h3>
              <span className="experience-date glow-pulse">April 2025 – Present</span>
            </div>
            <ul className="experience-list">
              <li>Built an AI‑powered website that transforms 15‑minute qualification calls into 60‑second warm leads</li>
              <li>Integrated OpenAI API and real‑time data capture to automate lead scoring and follow‑up workflows</li>
              <li>Currently finalising agreement with broker to pilot solution</li>
            </ul>
          </div>
          
          <div className="experience-item">
            <div className="experience-header">
              <h3>Founder & Growth Lead, Gachi Grills</h3>
              <span className="experience-date glow-pulse">March 2025 – Present</span>
            </div>
            <ul className="experience-list">
              <li>Launched direct‑to‑consumer foldable KBBQ table brand from zero to 25,000 Instagram followers</li>
              <li>Produced and executed organic content strategy driving over 16 million video views</li>
              <li>Achieved $27,000 in revenue within three weeks</li>
            </ul>
          </div>
          
          <div className="experience-item">
            <div className="experience-header">
              <h3>Previous Roles</h3>
            </div>
            <ul className="experience-list">
              <li>Security Officer (Jan 2024 – Apr 2025)</li>
              <li>Aged Care Assistant, Bupa (Sep 2023 – Dec 2024)</li>
              <li>Crew Member, McDonald's (Feb 2022 – Aug 2023)</li>
            </ul>
          </div>
        </div>
        
        <div 
          className="resume-section skills" 
          id="skills" 
          ref={sectionRefs.skills}
        >
          <h2 className="section-title">Skills & Technologies</h2>
          <div className="skills-grid">
            <div className="skills-group">
              <h3 className="glow">Languages & Frameworks</h3>
              <p>Farely new to most languages and frameworks, but I'm learning fast. Know the fundermentals of python, javascript, html, css and c. Very experienced vibe coder in flutter, react and next.js, and more.</p>
            </div>
            <div className="skills-group">
              <h3 className="glow">Tools & Platforms</h3>
              <p>OpenAI, Claude, Gemini, Cursor, Firebase, Git/GitHub, Adobe suite, Canva, Figma, Linux.</p>
            </div>
            <div className="skills-group">
              <h3 className="glow">Growth & Marketing</h3>
              <p>Good with social media strategy and content creation. Great at understanding the customer and selling the vision.</p>
            </div>
            <div className="skills-group">
              <h3 className="glow">Soft Skills</h3>
              <p>Rapid prototyping, scrappy execution, deadline-driven, self-starter, great at communication and managment. </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume; 